import { Injectable } from '@angular/core';

import { AppConfigService as WebConfigService } from '@foo/foo-web-framework';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends WebConfigService {
  constructor() {
    super();
  }

  override getAppLogo(): string {
    return '/assets/img/aec-wallet.svg';
  }

  override getAccountDefaultImage(): string {
    return '/assets/img/aec-wallet/account.svg';
  }
}
